/**
 * Rotas centralizadas — fonte única de verdade.
 * Usar SEMPRE estas constantes em <Link>, <NavLink> e navigate().
 */
export const ROUTES = {
  home: '/',
  about: '/quem-somos',
  events: '/eventos',
  eventDetail: '/eventos/:slug',
  notFound: '*',
} as const;

/**
 * Helper para construir a URL de um evento individual.
 *
 * @example
 * eventPath('fepro') // => '/eventos/fepro'
 */
export const eventPath = (slug: string): string => `/eventos/${slug}`;
